import { CircularProgress } from "@mui/material";

import { faPenLine, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "@/components/Button/Button";

import { Icon } from "@/components";

import { CompanyBalance } from "../../schema/company-balance";

interface ViewModeCompanyBalanceItemProps {
	data: CompanyBalance;
	isEditingInProcess: boolean;
	isLoading?: boolean;
	setIsEditing: (id: number) => void;
	setDeletingCompanyBalance: (CompanyBalance: CompanyBalance | null) => void;
}

export default function ViewModeCompanyBalanceItem({
	data,
	isEditingInProcess,
	isLoading,
	setIsEditing,
	setDeletingCompanyBalance,
}: ViewModeCompanyBalanceItemProps) {
	return (
		<div
			className={`w-full rounded-xl p-4 bg-white flex gap-3 items-center ${
				isEditingInProcess ? "cursor-not-allowed" : "cursor-pointer"
			}`}
			style={{ boxShadow: "0px 1px 2px 0px #1C274C1F" }}
		>
			{isLoading ? (
				<CircularProgress className="!w-10 !h-10 mx-auto" />
			) : (
				<>
					<div className="flex-1">
						<h4 className="text-primary-blue-dark text-[14px] font-semibold">{data?.value}</h4>
					</div>

					<div className="flex gap-2">
						<Button
							className="rounded-[12px] bg-white !min-w-[44px] !min-h-[44px] !max-w-[44px] !max-h-[44px] !p-0 !border-[0.28px] !border-[#E6E6EC] hover:bg-primary-gray-lightest"
							image={<Icon className="text-primary-blue-dark w-5 h-5" icon={faPenLine} />}
							title=""
							onClick={() => {
								if (data?.id) {
									setIsEditing(data?.id);
								}
							}}
						/>

						<Button
							className="rounded-[12px] bg-white !min-w-[44px] !min-h-[44px] !max-w-[44px] !max-h-[44px] !p-0 !border-[0.28px] !border-[#E6E6EC] hover:bg-primary-gray-lightest"
							image={<Icon className="text-primary-blue-dark w-5 h-5" icon={faTrashCan} />}
							title=""
							onClick={() => {
								if (data?.id) {
									setDeletingCompanyBalance(data);
								}
							}}
						/>
					</div>
				</>
			)}
		</div>
	);
}
